<h1 mat-dialog-title>
  <div [style.font-size.px]="media.isActive('lt-sm') ? '16' : ''">
    {{ 'LABEL_FILTER' | translate }}
  </div>
</h1>

<div mat-dialog-content fxLayout="column" fxAlign="center center">
  <div fxLayout="column" fxLayoutGap="20px">

    <form [formGroup]="formGroup" novalidate autocomplete="off" autocorrect="off">
      <div>
        <!-- Status -->
        <mat-form-field class="form-field-filter">
          <mat-label>
            {{ 'LABEL_STATUS' | translate }}
          </mat-label>

          <mat-select formControlName="status" [compareWith]="compareWithFunc" required>
            <mat-option *ngFor="let opt of statuses" [value]="opt">
              {{opt.description}}
            </mat-option>
          </mat-select>

          <mat-error *ngIf="formGroup.controls['status'].hasError('required')">
            {{ 'MSG_FIELD_REQUIRED' | translate }}
          </mat-error> 
        </mat-form-field>

        <!-- WebUser -->
        <mat-form-field class="width-100">
          <mat-chip-list #chipsWebUser aria-label="WebUser" [disabled]="formGroup.get('webuser').disabled">
            <mat-chip *ngFor="let data of multiSelect.selectedWebUsers" [removable]="true"
              (removed)="toggleSelection(
                    data,
                    filterOptions.webuser,
                    'selectedWebUsers',
                    'webuser',
                    webuserInput
                  )">
              {{
              data.description === 'All'
              ? data.description
              : data.code + ' - ' + data.description
              }}
              <mat-icon matChipRemove aria-hidden="false" aria-label="remove">cancel</mat-icon>
            </mat-chip>

            <input matInput #webuserInput [matChipInputFor]="chipsWebUser" formControlName="webuser"
              [matChipInputAddOnBlur]="true" [matAutocomplete]="webuserAC" (focus)="getInitialData('webuser')"
              (blur)="
            checkAutocompleteObject(
              formGroup,
              'webuser',
              'selectedWebUsers'
            )"
            [disabled]="formGroup.get('webuser').disabled"
            [placeholder]="'LABEL_WEB_USER' | translate" />

            <mat-icon matSuffix svgIcon="menu-down" *ngIf="!webuserInput.value"
              class="autocomplete-arrow-color cursor-pointer" (click)="webuserInput.focus()">
            </mat-icon>
          </mat-chip-list>

          <mat-autocomplete [displayWith]="displayFn" #webuserAC="matAutocomplete" (opened)="
          autocompleteScroll('webuser', 'webuserACRef', 'webuserACTr')" (closed)="onFilterClose('webuser', webuserInput)">
            <mat-option disabled *ngIf="!loading.webuser && filterOptions.webuser?.length == 0">
              {{ 'MSG_NO_DATA' | translate }}
            </mat-option>

            <ng-container>
              <mat-option *ngFor="let data of filterOptions.webuser" [value]="data" [disabled]="data.disabled">
                <div (click)="
                !data.disabled &&
                  optionClicked(
                    $event,
                    data,
                    filterOptions.webuser,
                    'selectedWebUsers',
                    'webuser',
                    webuserInput
                  )
              " [class.disable]="data.disabled">
                  <mat-checkbox [checked]="data.selected" (change)="
                  toggleSelection(
                    data,
                    filterOptions.webuser,
                    'selectedWebUsers',
                    'webuser',
                    webuserInput
                  )
                " (click)="$event.stopPropagation()" [disabled]="data.disabled">
                    {{
                    data.description === 'All'
                    ? data.description
                    : data.code + ' - ' + data.description
                    }}
                  </mat-checkbox>
                </div>
              </mat-option>
            </ng-container>

            <mat-option *ngIf="loading.webuser" disabled>
              <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate"
                [diameter]="45"></mat-spinner>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </form>

  </div>
</div>

<div mat-dialog-actions *ngIf="!media.isActive('lt-sm')" fxLayout fxLayoutAlign="end center">
  <button type="button" color="primary" mat-button (click)="applyFilters()"> {{ 'LABEL_APPLY' | translate }} </button>
  <button type="button" color="warn" mat-button (click)="reset()"> {{ 'LABEL_RESET' | translate }} </button>
  <button type="button" mat-button (click)="dialogRef.close()"> {{ 'LABEL_CANCEL' | translate }} </button>
</div>

<!-- buttons for mobile view -->
<div mat-dialog-actions *ngIf="media.isActive('lt-sm')" fxLayout fxLayoutAlign="end center">
  <button type="button" color="primary" mat-icon-button (click)="applyFilters()">
    <mat-icon svgIcon="check"></mat-icon>
  </button>

  <button type="button" color="warn" mat-icon-button (click)="reset()">
    <mat-icon svgIcon="restore"></mat-icon>
  </button>

  <button type="button" mat-icon-button (click)="dialogRef.close()">
    <mat-icon svgIcon="cancel"></mat-icon>
  </button>
</div>